import React from "react";

import { Col, Row } from "react-bootstrap";

import classNames from "classnames";

import { ParticipantTypes } from "@api/graphql";
import { formatPercentage } from "@util/index";

import styles from "./AddBeneficiaryModal.module.scss";

interface BeneficiaryHeaderProps {
  rootArtistName: string;
  percentageShare: number;
  participantName: string;
  participantType?: ParticipantTypes[];
  companyName?: string;
}

export const BeneficiaryModalHeader = ({
  rootArtistName,
  percentageShare,
  participantName,
  participantType,
  companyName,
}: BeneficiaryHeaderProps) => {
  const isCollaborationAccount = participantType?.includes(ParticipantTypes.COLLABORATION);
  return (
    <>
      <Row className="mb-4 h5">Add Beneficiaries</Row>
      <Row className="mb-4">
        <Col>
          <Row className={classNames(styles["label"])}>Associated Artist</Row>
          <Row className={classNames(styles["artist-name"], "h5")}>
            {isCollaborationAccount ? companyName : rootArtistName}
          </Row>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col>
          <Row className={classNames("h6")}>Add Beneficiaries to:</Row>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={2}>
          <Row className={classNames(styles["label"])}>Share</Row>
          <Row className={classNames("h5")}>{formatPercentage(percentageShare)}%</Row>
        </Col>
        <Col>
          <Row className={classNames(styles["label"])}>Account</Row>
          <Row className={classNames(styles["artist-name"], "h5")}>
            {isCollaborationAccount ? companyName : participantName}
          </Row>
        </Col>
      </Row>
    </>
  );
};
